import { FeaturePanel } from '@engine/features/feature_panel';
import { exists } from '@engine/lib/utility/exists';
var container = '.return-urls-panel-wrapper';
var auto_return_block = '.auto-return-data-container';
var return_delay_block = '.return-delay-data-container';
var AutoReturnPanel = new FeaturePanel(auto_return_block, {
  errorMessageTemplate: function errorMessageTemplate(message, errors) {
    return message + '</br>' + errors[1];
  }
});
var ReturnDelayPanel = new FeaturePanel(return_delay_block, {
  errorMessageTemplate: function errorMessageTemplate(message, errors) {
    return message + '</br>' + errors[1];
  }
});

function autoReturnChoice() {
  return $('input[name="auto_return"]:checked').val();
}

function returnDelayValue() {
  return $('input[name="return_delay"]').val();
}

function toggleReturnDelayBlock() {
  $(return_delay_block).toggle(autoReturnChoice() === 'with delay');
}

function validateReturnDelay(returnDelayInput) {
  var MAX = 300;
  var MIN = 5;
  var returnDelay = returnDelayInput.value;

  if (returnDelay > MAX) {
    returnDelayInput.value = MAX;
  } else if (returnDelay < MIN) {
    returnDelayInput.value = MIN;
  }
}

function initAutoReturnButtons() {
  $('input[name="auto_return"]:checked').closest('.btn').toggleClass('active');
  toggleReturnDelayBlock();
}

function listenForUpdates() {
  var $returnUrlsPanel = $(container);

  if (exists($returnUrlsPanel)) {
    initAutoReturnButtons();
    $(document).on('change', 'input[name="auto_return"]', function () {
      AutoReturnPanel.update({
        auto_return: autoReturnChoice()
      });
      toggleReturnDelayBlock();
    });
    $(document).on('change', 'input[name="return_delay"]', function () {
      ReturnDelayPanel.update({
        return_delay: returnDelayValue()
      });
    });
    $(document).on('keyup', 'input[name="return_delay"]', function (event) {
      validateReturnDelay(event.target);
    });
  }
}

var ReturnUrls = {
  listenForUpdates: listenForUpdates
};
export default ReturnUrls;